export const toDataURL = async (src) => {
  return new Promise((resolve, reject) => {
    let image = new Image()
    image.crossOrigin = 'Anonymous'
    image.onload = () => {
      var canvas = document.createElement('canvas')
      var context = canvas.getContext('2d')
      canvas.height = image.naturalHeight
      canvas.width = image.naturalWidth
      context.drawImage(image, 0, 0)
      // without image quaility set
      var dataURL = canvas.toDataURL('image/jpeg')
      // with image quaility set
      // var dataURL = canvas.toDataURL('image/jpeg', 0.8)
      resolve(dataURL)
    };
    image.src = src
  });
}


/**
 * @param {File} fileInput - Original Image File as Base64 DataUrl
 * @param {String} fileName - Name of the file
 * @param {Number} quality - defaults to 0.8
 */
export const getImageBlob = async (fileInput, fileName, quality = 0.8) => {

  return new Promise((resolve, reject) => {
    let img = new Image();
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');

    img.onload = async () => {

      canvas.width = img.width;
      canvas.height = img.height;

      ctx.drawImage(
        img,
        0,
        0,
        img.width,
        img.height,
        0,
        0,
        img.width,
        img.height
      );
  
      let getBlob = convertBase64toBlob(canvas.toDataURL('image/jpeg', quality));
  
      return getBlob.then(blob => {
        let fileForUpload = new File([blob], fileName);
        resolve(fileForUpload);
      });

    };

    img.src = fileInput;

  });

}



/**
 * @param {File} fileInput - Original Image File as Base64 DataUrl
 * @param {String} fileName - Name of the file
 * @param {Object} pixelCrop - pixelCrop Object from the 2nd argument of onChange or onComplete
 * @param {Boolean} mobile - crop to small size
 * @param {Number} quality - defaults to 0.8
 */
export const getCroppedImageBlob = async (fileInput, fileName, pixelCrop, mobile = false, quality = 0.8) => {

  return new Promise((resolve, reject) => {
    let img = new Image();
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');
    img.onload = async () => {
      let maxW = mobile ? 300 : 1000;
      let maxH = mobile ? 300 : 1000;
      let iw = pixelCrop.width;
      let ih = pixelCrop.height;
      let scale = Math.min((maxW/iw),(maxH/ih));
      let iwScaled = iw*scale;
      let ihScaled = ih*scale;
      canvas.width = iwScaled;
      canvas.height = ihScaled;

      ctx.drawImage(
        img,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        iwScaled,
        ihScaled
      );

      let getBlob = convertBase64toBlob(canvas.toDataURL('image/jpeg', quality));
      return getBlob.then(blob => {
        let fileForUpload = new File([blob], fileName);
        resolve(fileForUpload);
      });
    };
    img.src = fileInput;
  });
}


export const convertBase64toBlob = (image) => {
  return fetch(image)
    .then(res => res.blob())
    .then(blob => blob);
}

export default {
  toDataURL,
  getImageBlob,
  getCroppedImageBlob,
  convertBase64toBlob,
};
